/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles, Typography } from '@material-ui/core';
import PageTitle from 'components/PageTitle';
import RefreshButton from 'components/RefreshButton';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import i18n from 'i18n';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Button from 'components/Button';
import { AuditLogsResponse, AuditLogsResults } from 'modules/audit/interfaces';
import { cyrb53Hash, formatDateWithMoment, applyI18n } from 'utils/helpers';
import {
  getAuditLogsRequest,
  getContextAuditLogsRequest,
} from 'modules/audit/actions';
import GenericForm from 'skyone-lib/lib/GenericForm';
import { Formik } from 'formik';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import clsx from 'clsx';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import { ModalFields } from 'modules/modal/interfaces';
import { modalOpen, modalClose } from 'modules/modal/actions';
import { useTableFilters } from 'hooks/useTableFilters';
import { SearchBar } from 'components/SearchBar';
import styles, { overrideModalText } from './styles';
import screenFields from './screenFields';
import LogsDetails from './LogsDetails';
import { getResourceTypeText, getActionText } from './utils';

const useStyles = makeStyles(styles);

const initialQuery = {
  offset: 0,
  limit: 25,
  search: '',
};

interface Props {
  isLoading: boolean;
  auditLogsData: AuditLogsResponse;
  companySelected: CompanyData | null;
  role?: RolesEnum;
  title?: string;
  subtitle?: string;
  isContextPage?: boolean;
  context?: string;
  contextId?: string;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
  getAuditLogsRequest: (props) => void;
  getContextAuditLogsRequest: (props) => void;
}

const ListAllLogs = ({
  isLoading,
  auditLogsData,
  companySelected,
  role,
  title,
  subtitle,
  isContextPage = false,
  context,
  contextId,
  modalOpen,
  modalClose,
  getAuditLogsRequest,
  getContextAuditLogsRequest,
}: Props) => {
  const classes = useStyles();

  const {
    itemOrder,
    query,
    searchValue,
    setQuery,
    handleOrder,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);

  const [filter, setFilter] = React.useState<any>('all');
  const [listSwitch, setListSwitch] = React.useState(isContextPage);
  const [refresh, setRefresh] = React.useState(false);

  const headers = [
    {
      key: 'user__first_name',
      i18n: 'OPERATOR_NAME_KEY',
      order: true,
    },
    {
      key: 'user__email',
      i18n: 'EMAIL_KEY',
      order: true,
    },
    {
      key: 'action',
      i18n: 'ACTION_KEY',
      order: true,
      centerTitle: true,
      textAlignCenter: true,
    },
    {
      key: 'resource',
      i18n: 'LOGS_PAGE.RESOURCE_TYPE_KEY',
      order: true,
      centerTitle: true,
      textAlignCenter: true,
      hidden: isContextPage,
    },
    {
      key: 'resource_identifier',
      i18n: 'LOGS_PAGE.RESOURCE_KEY',
      hidden: isContextPage,
      order: true,
    },
    {
      key: 'created_at',
      i18n: 'DATE_KEY',
      order: true,
      centerTitle: true,
      textAlignCenter: true,
    },
    {
      key: '',
      i18n: 'LOGS_PAGE.DETAILS_KEY',
      centerTitle: true,
      textAlignCenter: true,
    },
  ].filter(item => !item.hidden);

  const getAuditLogs = (refresh = false) => {
    if (isContextPage) {
      getContextAuditLogsRequest({
        query: { ...query },
        resource: context,
        resource_uuid: contextId,
        action: filter,
      });
    } else {
      getAuditLogsRequest({
        ...query,
      });
    }

    setRefresh(refresh);
  };

  const handleGetAuditLogs = (search: string) => {
    if (isContextPage) {
      getContextAuditLogsRequest({
        query: { ...query },
        search,
        resource: context,
        resource_uuid: contextId,
        action: filter,
      });
    } else {
      getAuditLogsRequest({
        ...query,
        search,
      });
    }
    setListSwitch(true);
  };

  React.useEffect(() => {
    if (listSwitch === true) {
      getAuditLogs();
    }
  }, [query, filter]);

  const openDetailsModal = (item: AuditLogsResults) => {
    modalOpen({
      title: i18n.t('LOGS_PAGE.MODAL_DETAILS_TITLE_KEY'),
      content: <LogsDetails auditLog={item} />,
      noBorder: true,
      overrideClasses: overrideModalText,
      footer: (
        <Grid>
          <Button id="close-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CLOSE_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  return (
    <Grid container>
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="space-between"
        className={classes.titleMargin}
      >
        <PageTitle
          title={title || i18n.t('LOGS_PAGE.LIST_LOGS_TITLE_KEY')}
          subtitle={subtitle || i18n.t('LOGS_PAGE.LIST_LOGS_SUBTITLE_KEY')}
        />

        <Grid item>
          <RefreshButton
            id="btn-refresh"
            onClick={() => getAuditLogs(true)}
            animate={isLoading}
            className={classes.refreshButton}
            disabled={isLoading}
          />
        </Grid>
      </Grid>

      <Grid item xs={7} className={classes.searchContainer}>
        <Grid item xs={9} className={classes.searchSize}>
          <SearchBar
            id="search-logs"
            isLoading={isLoading}
            searchValue={searchValue}
            handleSearch={handleSearch}
            setSearchValue={setSearchValue}
            onSearchComplete={() => setListSwitch(true)}
          />
        </Grid>
        {!isContextPage && (
          <Grid item xs={3} className={classes.switch}>
            <Button
              className={clsx(classes.searchButtonSize, {
                [classes.buttonIsLoading]: isLoading,
              })}
              id="search-all-logs"
              variant="outlined"
              onClick={() => {
                handleGetAuditLogs(searchValue);
              }}
              disabled={isLoading}
            >
              <Typography className={classes.listAll}>
                {i18n.t('SEARCH_ALL_KEY')}
              </Typography>
            </Button>

            <Button
              id="list-all-logs"
              className={clsx(classes.listButtonSize, {
                [classes.buttonIsLoading]: isLoading,
              })}
              variant="outlined"
              pressed={listSwitch}
              disabled={isLoading}
              onClick={() => {
                if (listSwitch === false) {
                  getAuditLogs();
                  setListSwitch(!listSwitch);
                  setQuery(initialQuery);
                } else {
                  setListSwitch(!listSwitch);
                  setQuery(initialQuery);
                }
              }}
            >
              <Typography className={classes.listAll}>
                {i18n.t('LIST_ALL_KEY')}
              </Typography>
            </Button>
          </Grid>
        )}
      </Grid>
      <Grid item xs={5} className={classes.filtersGrid}>
        <Formik
          initialValues={{ advisor_type: '' }}
          onSubmit={values => setQuery(prev => ({ ...prev, ...values }))}
          enableReinitialize
        >
          {({ setFieldValue, errors, values }) => (
            <Grid item xs={10} spacing={2}>
              <Grid
                item
                spacing={2}
                className={classes.filters}
                justify="flex-end"
              >
                <Typography
                  className={clsx(classes.defaultFilters, {
                    [classes.adminFilters]: inAdminView(role, companySelected),
                    [classes.superAdminFilters]: inSuperAdminView(
                      role,
                      companySelected
                    ),
                    [classes.operatorFilters]: inOperatorView(
                      role,
                      companySelected
                    ),
                  })}
                >
                  {i18n.t('LOGS_PAGE.FILTERS_KEY')}
                  {':'}
                </Typography>
                {!isContextPage && (
                  <GenericForm
                    fields={values}
                    errors={errors}
                    screenFields={applyI18n(
                      screenFields.slice(0, 1),
                      i18n.language
                    )}
                    setFieldValue={(key, value) => {
                      setFieldValue(key, value);
                      setQuery(prev => ({
                        ...prev,
                        offset: 0,
                        [key]: value === 'all' ? '' : value,
                      }));
                    }}
                    overrideClasses={{
                      selectLabel: { fontSize: 12, fontWeight: 500 },
                    }}
                  />
                )}
                <GenericForm
                  fields={values}
                  errors={errors}
                  screenFields={applyI18n(
                    screenFields.slice(1, 2),
                    i18n.language
                  )}
                  setFieldValue={(key, value) => {
                    setFieldValue(key, value);
                    setFilter(value);
                    setQuery(prev => ({
                      ...prev,
                      offset: 0,
                      [key]: value === 'all' ? '' : value,
                    }));
                  }}
                  overrideClasses={{
                    selectLabel: { fontSize: 12, fontWeight: 500 },
                  }}
                />
              </Grid>
            </Grid>
          )}
        </Formik>
      </Grid>
      <Grid container className={classes.searchContainer}>
        {listSwitch && (
          <TableItems
            header={
              <>
                {headers.map(item => (
                  <TableCell
                    centerTitle={item?.centerTitle}
                    textAlignCenter={item?.textAlignCenter}
                    key={item?.key}
                    markOderItem={itemOrder === item?.key}
                    order={item?.order}
                    handleOrder={() =>
                      item?.order ? handleOrder(item?.key) : null
                    }
                  >
                    {i18n.t(item?.i18n)}
                  </TableCell>
                ))}
              </>
            }
            renderItems={(item: AuditLogsResults, index) => (
              <TableRow
                key={cyrb53Hash(String(index))}
                onClick={() => openDetailsModal(item)}
              >
                <TableCell maxLength={30} ellipsis className={classes.textLong}>
                  <Typography className={classes.nameField}>
                    {item?.user
                      ? `${item?.user?.first_name} ${item?.user?.last_name}`
                      : i18n.t('AUTOSKY_ROUTINE')}
                  </Typography>
                </TableCell>
                <TableCell maxLength={45} ellipsis className={classes.textLong}>
                  {item?.user?.email}
                </TableCell>
                <TableCell className={classes.centerFields}>
                  {getActionText(item?.action)}
                </TableCell>
                {!isContextPage && (
                  <>
                    <TableCell className={classes.centerFields}>
                      {getResourceTypeText(item?.resource)}
                    </TableCell>
                    <TableCell>{item?.resource_identifier}</TableCell>
                  </>
                )}
                <TableCell align="center" className={classes.centerFields}>
                  {formatDateWithMoment(item?.created_at)}
                </TableCell>
                <TableCell align="center">
                  <InfoOutlinedIcon
                    onClick={() => openDetailsModal(item)}
                    className={clsx(classes.defaultIcon, {
                      [classes.adminIcon]: inAdminView(role, companySelected),
                      [classes.superAdminIcon]: inSuperAdminView(
                        role,
                        companySelected
                      ),
                      [classes.operatorIcon]: inOperatorView(
                        role,
                        companySelected
                      ),
                    })}
                  />
                </TableCell>
              </TableRow>
            )}
            data={auditLogsData}
            isLoading={!refresh && isLoading}
            onChangePage={handlePageChange}
            onChangeLimit={handleLimitChange}
            notFoundText={i18n.t('LOGS_PAGE.NO_LOGS_KEY')}
          />
        )}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  audit: { isLoading, auditLogsData },
  authenticate: { companySelected, data },
}: ApplicationState) => ({
  isLoading,
  auditLogsData,
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {
  getAuditLogsRequest,
  getContextAuditLogsRequest,
  modalOpen,
  modalClose,
})(ListAllLogs);
